function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Button from '../../common/Button.react';
var Slot = function Slot(_ref) {
  var type = _ref.type,
    items = _ref.items,
    route = _ref.route,
    formData = _ref.formData;
  var dispatch = useDispatch();
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState(items),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    updated = _useState4[0],
    setUpdated = _useState4[1];
  var _useState5 = useState({
      draggedFrom: null,
      draggedTo: null,
      isDragging: false,
      originalOrder: [],
      updatedOrder: []
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    dragAndDrop = _useState6[0],
    setDragAndDrop = _useState6[1];

  // onDragStart fires when an element
  // starts being dragged
  var onDragStart = function onDragStart(event) {
    var initialPosition = Number(event.currentTarget.dataset.position);
    setDragAndDrop(_objectSpread(_objectSpread({}, dragAndDrop), {}, {
      draggedFrom: initialPosition,
      isDragging: true,
      originalOrder: list
    }));

    // Note: this is only for Firefox.
    // Without it, the DnD won't work.
    // But we are not using it.
    event.dataTransfer.setData('text/html', '');
  };

  // onDragOver fires when an element being dragged
  // enters a droppable area.
  // In this case, any of the items on the list
  var onDragOver = function onDragOver(event) {
    // in order for the onDrop
    // event to fire, we have
    // to cancel out this one
    event.preventDefault();
    var newList = dragAndDrop.originalOrder;

    // index of the item being dragged
    var draggedFrom = dragAndDrop.draggedFrom;

    // index of the droppable area being hovered
    var draggedTo = Number(event.currentTarget.dataset.position);
    var itemDragged = newList[draggedFrom];
    var remainingItems = newList.filter(function (items, index) {
      return index !== draggedFrom;
    });
    newList = [].concat(_toConsumableArray(remainingItems.slice(0, draggedTo)), [itemDragged], _toConsumableArray(remainingItems.slice(draggedTo)));
    if (draggedTo !== dragAndDrop.draggedTo) {
      setDragAndDrop(_objectSpread(_objectSpread({}, dragAndDrop), {}, {
        updatedOrder: newList,
        draggedTo: draggedTo
      }));
    }
  };
  var onDrop = function onDrop() {
    setList(dragAndDrop.updatedOrder);
    setDragAndDrop(_objectSpread(_objectSpread({}, dragAndDrop), {}, {
      draggedFrom: null,
      draggedTo: null,
      isDragging: false
    }));
  };
  var onDragLeave = function onDragLeave() {
    setDragAndDrop(_objectSpread(_objectSpread({}, dragAndDrop), {}, {
      draggedTo: null
    }));
  };
  var onSave = function onSave() {
    var slotObj = {};
    list.forEach(function (x, i) {
      slotObj[x.id] = i;
    });
    dispatch({
      type: cmsActions.slot,
      payload: {
        formData: _objectSpread(_objectSpread({}, formData), {}, {
          list: slotObj
        }),
        route: route,
        apiID: 'slot'
      }
    });
    dispatch({
      type: modalActions.hide
    });
  };

  // Not needed, just for logging purposes:
  useEffect(function () {
    console.log('Dragged From: ', dragAndDrop && dragAndDrop.draggedFrom);
    console.log('Dropping Into: ', dragAndDrop && dragAndDrop.draggedTo);
  }, [dragAndDrop]);
  useEffect(function () {
    setUpdated(JSON.stringify(items) !== JSON.stringify(list));
  }, [list]);
  return /*#__PURE__*/React.createElement("div", {
    className: "modal slot"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Sort List"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("ul", null, type === 'images' && list.map(function (x, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: x.id,
      "data-position": index,
      draggable: true,
      onDragStart: onDragStart,
      onDragOver: onDragOver,
      onDrop: onDrop,
      onDragLeave: onDragLeave,
      className: [dragAndDrop && dragAndDrop.draggedTo === Number(index) ? 'dropArea' : '', 'slot__image'].join(' ')
    }, /*#__PURE__*/React.createElement("div", {
      className: "slot__image--body"
    }, /*#__PURE__*/React.createElement("img", {
      src: "".concat(bucket, "/").concat(x.filename)
    })));
  }))), /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    apiID: "slot",
    disabled: !updated,
    onClick: function onClick() {
      onSave();
    }
  })));
};
export default Slot;